<template>
  <tr
    class="content-row cursor-pointer animated flipInX"
    :class="{ 'selected': isSelected }"

    @dblclick="dblClickAction"
    :id="`file-${element.id}`"
  >
    <!-- ESTADOS  -->
    <td class="text-center">
      <div v-if="element.type === 'file'">
        <!-- publication state icon -->
        <span class="pr-1">
          <font-awesome-icon
            :icon="['fas', publicationStateIcon(element).icon]"
            :class="publicationStateIcon(element).classes"
            v-tooltip="publicationStateIcon(element).tooltip"
            size="xs"
          />
        </span>
        <!-- validity state icon -->
        <span class="pr-1">
          <font-awesome-icon
            :icon="['fas', validityStateIcon(element).icon]"
            :class="validityStateIcon(element).classes"
            v-tooltip="validityStateIcon(element).tooltip"
            size="xs"
          />
        </span>
        <!-- approval state icon -->
        <span class="pr-1">
          <font-awesome-icon
            :icon="['fas', approvalStateIcon(element).icon]"
            :class="approvalStateIcon(element).classes"
            v-tooltip="approvalStateIcon(element).tooltip"
            size="xs"
          />
        </span>
      </div>
    </td>
    <!-- NOMBRE -->
    <td @click="clicksCheck" class="noselect">
      <!-- element type icon -->
      <span class="pt-3">
        <font-awesome-icon
          :icon="['fas', 'folder']"
          style="color: orange"
          v-if="element.type === 'folder'"
        />
        <font-awesome-icon
          :icon="['fas', fileTypeIcon(element)]"
          :class="fileTypeIcon(element)"
          v-if="element.type === 'file'"
        />
      </span>
      {{ element.name }}
      <span
        v-if="element.documentId"
        class="material-icons" style="font-size: 18px;color:dodgerblue"
      >
        link
      </span>
      <div v-if="element.type === 'folder'">
        <b-badge
          v-tooltip="'Cantidad de carpetas'"
          v-if="element.numberOfFolders"
          variant="light-success"
          class="mr-2"
        >
          <font-awesome-icon
            :icon="['fas', 'folder']"
            style="color: #386f17;"
          />
          {{element.numberOfFolders}}
        </b-badge>
        <b-badge
          v-tooltip="'Cantidad de archivos'"
          v-if="element.numberOfFiles"
          variant="light-info"
          class="mr-2"
        >
          <font-awesome-icon
            :icon="['fas', 'file-archive']"
            style="color: #006c79;"
          />
          {{element.numberOfFiles}}
        </b-badge>
      </div>
    </td>
    <!-- TAMAÑO -->
    <td class="text-center text-gray">
      {{ size }}
    </td >
    <!-- FECHA PUBLICACIÓN -->
    <td class="text-gray">
      {{ $moment(element.creationDate).format('DD-MM-YYYY H:mm') }}
    </td>
    <!-- PUBLICADO POR -->
    <td class="text-gray">
      {{ element.owner }}
    </td>
  </tr>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faFileImage, faFile, faFileVideo, faFileAudio, faFileCsv, faFileAlt,
  faFileArchive, faFilePdf, faFilePowerpoint, faFileExcel, faFileWord,
  faExclamationCircle, faCheckCircle, faCircle, faCalendar, faCalendarCheck,
  faCalendarTimes, faTimesCircle, faUserCircle, faEdit

} from '@fortawesome/free-solid-svg-icons';

import { ioEDFilesGet, ioEDFoldersGet } from '@/febos/servicios/api/repositories.api';
import EDIcons from '@/febos/global/documentManagement/mixins/EDIcons';

library.add(
  faFileImage,
  faFile,
  faFileVideo,
  faFileAudio,
  faFileCsv,
  faFileAlt,
  faFileArchive,
  faFilePdf,
  faFilePowerpoint,
  faFileExcel,
  faFileWord,
  faExclamationCircle,
  faCheckCircle,
  faCircle,
  faCalendar,
  faCalendarCheck,
  faCalendarTimes,
  faTimesCircle,
  faUserCircle,
  faEdit
);

export default {
  name: 'rs-navigation-element',
  props: {
    element: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      counter: 0
    };
  },
  mixins: [EDIcons],
  methods: {
    ...mapActions('DocManagement', [
      'loadTree',
      'loadFiles',
      'setSelectedFolderId',
      'setSelectedElement',
      'setLoading'
    ]),
    roundToTwoDecimals(num) {
      return Math.round((num + Number.EPSILON) * 100) / 100;
    },
    clicksCheck() {
      this.counter += 1;
      if (this.counter === 1) {
        this.timer = setTimeout(() => {
          this.counter = 0;
          this.selectElement();
        }, 300);
        // return;
      } else {
        this.dblClickAction();
        clearTimeout(this.timer);
        this.counter = 0;
      }
    },
    dblClickAction() {
      if (this.element.type === 'folder') {
        // this.getElements();
        this.$root.$emit('open-folder', this.element.id); // like this
      }
    },
    async selectElement() {
      this.setLoading(true);
      if (this.element.type === 'file') {
        try {
          const response = await ioEDFilesGet({
            repositoryId: this.element.repositoryId,
            fileId: this.element.id
          });
          const newElement = response.data;
          await this.setSelectedElement({
            id: newElement.archivo.archivoId,
            name: newElement.archivo.nombre,
            creationDate: newElement.archivo.fechaCreacion,
            publicationDate: newElement.archivo.fechaPublicacion,
            parentFolder: this.element.id,
            ownerId: newElement.archivo.propietario.id,
            owner: newElement.archivo.propietario.alias,
            size: newElement.archivo.pesoArchivo,
            type: 'file',
            documentId: newElement.archivo.documentoId,
            codeType: newElement.archivo.codType,
            repositoryId: this.element.repositoryId,
            downloadURL: `${newElement.archivo.urlDescarga}?t=${this.currentUser.token}&e=${this.companyId}`,
            publicLink: newElement.archivo.esPublico === 'S' ? newElement.archivo.urlDescarga : undefined,
            isPublic: newElement.archivo.esPublico === 'S',
            internalVersion: newElement.archivo.versionInterna,
            externalVersion: newElement.archivo.versionExterna,
            language: newElement.archivo.idioma,
            tags: newElement.tags,
            keywords: newElement.keywords,
            mimeType: newElement.archivo.mime,
            evaluation: newElement.archivo.evaluacion || 0,
            validityState: newElement.archivo.estadoVigencia,
            approvalState: newElement.archivo.estadoAprobacion,
            publicationState: newElement.archivo.estadoPublicacion,
            expirationDate: newElement.archivo.fechaVencimiento,
            notificationDate: newElement.archivo.fechaNotificacion,
            expirationType: newElement.archivo.tipoExpiracion,
            loggedUserPermissions: newElement.misPermisos
          });
        } finally {
          this.setLoading(false);
        }
      } else if (this.element.type === 'folder') {
        try {
          const response = await ioEDFoldersGet({
            repositoryId: this.element.repositoryId,
            folderId: this.element.id
          });
          const {
            tags,
            keywords,
            permisos,
            comentarios,
            carpeta,
            misPermisos
          } = response.data;
          await this.setSelectedElement(
            {
              id: carpeta.carpetaId,
              name: carpeta.nombre,
              fullpath: carpeta.fullpath,
              fullpathId: carpeta.fullpathId,
              parentFolder: this.element.parentFolder,
              repositoryId: this.element.repositoryId,
              creationDate: carpeta.fechaCreacion,
              ownerId: this.element.ownerId,
              owner: this.element.owner,
              tags,
              keywords,
              permissions: permisos,
              comments: comentarios,
              type: 'folder',
              numberOfFolders: carpeta.cantidadCarpetas,
              numberOfFiles: carpeta.cantidadArchivos,
              loggedUserPermissions: misPermisos
            }
          );
        } finally {
          this.setLoading(false);
        }
      }
      this.setLoading(false);
    },
    async getElements() {
      this.setSelectedFolderId(this.element.id);
      this.loadTree({
        repositoryId: this.element.repositoryId,
        parentFolder: this.element.id,
        path: `${this.element.fullpathId}/${this.element.id}`
      });
      await this.loadFiles({
        repositoryId: this.element.repositoryId,
        parentFolder: this.element.id,
        path: this.element.id
      });
    }
  },
  computed: {
    size() {
      if (typeof this.element.size === 'undefined' || this.element.size === '') {
        return '--';
      }
      const units = ['bytes', 'kb', 'mb', 'gb', 'tb'];
      let actualUnit = 0;
      const amountOfUnitsForNextLevel = 1024;
      let actualSize = this.element.size;
      while (actualSize >= amountOfUnitsForNextLevel) {
        actualSize = this.roundToTwoDecimals(actualSize / amountOfUnitsForNextLevel);
        actualUnit += 1;
      }
      return [actualSize, units[actualUnit]].join(' ');
    },
    isSelected() {
      return this.getSelectedElement && this.element.id === this.getSelectedElement.id;
    },
    ...mapGetters('DocManagement', [
      'getSelectedElement'
    ]),
    ...mapGetters('Usuario', [
      'currentUser'
    ]),
    ...mapGetters('Empresas', [
      'companyId'
    ])
  },
};
</script>

<style lang="scss" scoped>
.text-orange {
  color: orange;
}

.selected {
  background: lightgray;
}

.noselect {
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.content-row:hover {
  background-color: lightgray;
}
.text-gray{
  color: #aaa!important;
}
</style>
